import { render, staticRenderFns } from "./bank-gateways.vue?vue&type=template&id=1cf68a49"
import script from "./bank-gateways.vue?vue&type=script&lang=js"
export * from "./bank-gateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports